import { render, staticRenderFns } from "./ChatConversationCard.vue?vue&type=template&id=5cca2738&scoped=true&"
import script from "./ChatConversationCard.vue?vue&type=script&lang=js&"
export * from "./ChatConversationCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatConversationCard.vue?vue&type=style&index=0&id=5cca2738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca2738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
